import { StateCreator } from 'zustand';
import { IAppStore } from '../../../IAppStore';
import PrintSlice, { PrintSliceProps } from './PrintSlice';

export const defaultPrintSliceProps: PrintSliceProps = {
  layoutTitle: '',
  layoutSubTitle: '',
  printLegend: true,
  printScale: 1000,
  mapExtent: undefined,
  layoutId: 'AgisDefault',
  orientation: 'landscape',
  formatValue: 'A4',
  angle: 0,
  showPrintPreview: false,
  printMapOnly: false,
  printedItems: [],
  showPrintedItems: false,
};

const createPrintSlice: StateCreator<IAppStore, [], [], PrintSlice> = (set, get) => ({
  ...defaultPrintSliceProps,
  setLayoutTitle: (layoutTitle) => set({ layoutTitle }),
  setLayoutSubTitle: (layoutSubTitle) => set({ layoutSubTitle }),
  togglePrintLegend: () => set({ printLegend: !get().printLegend }),
  setPrintScale: (printScale) => set({ printScale }),
  setMapExtent: (mapExtent) => set({ mapExtent }),
  setLayoutId: (layoutId: any) => set({ layoutId }),
  setOrientation: (orientation: string) => set({ orientation }),
  setFormatValue: (formatValue: string) => set({ formatValue }),
  setAngle: (angle) => {
    const angleInRadians = angle * (Math.PI / 180);
    set({ angle, location: { ...get().location, rotation: angleInRadians } });
  },
  togglePrintMapOnly: () => set({ printMapOnly: !get().printMapOnly }),
  addPrintedItem: (label, url, icon) => {
    const expire = new Date();
    expire.setTime(expire.getTime() + 3_600_000);
    set((state) => ({
      printedItems: [...state.printedItems, { label, url, icon, expire }],
    }));
  },
  cleanPrintedItem: () => {
    const now = new Date();
    set((state) => ({
      printedItems: state.printedItems.filter((item) => item.expire > now),
    }));
  },
  toggleShowPrintedItems: () => set({ showPrintedItems: !get().showPrintedItems }),
  resetPrint: () =>
    set({
      ...defaultPrintSliceProps,
      location: { ...get().location, rotation: 0 },
      printedItems: get().printedItems,
    }),
});

export default createPrintSlice;
